exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2rg5ailL1jR7Z2DjmlnENx{position:relative}html[dir=ltr] ._2rg5ailL1jR7Z2DjmlnENx{margin-right:6px}html[dir=rtl] ._2rg5ailL1jR7Z2DjmlnENx{margin-left:6px}._1jHQ218J9GUuXKTH-Xd56L{width:13px;height:13px;position:absolute;top:19px}html[dir] ._1jHQ218J9GUuXKTH-Xd56L{border-radius:50%;border:2px solid \"[theme:white, default:#ffffff]\";background-color:#e63236}html[dir=ltr] ._1jHQ218J9GUuXKTH-Xd56L{left:19px}html[dir=rtl] ._1jHQ218J9GUuXKTH-Xd56L{right:19px}html[dir] ._1jHQ218J9GUuXKTH-Xd56L._4aIG4GKXJFxP1-9D4cFzp{background-color:#0eb244}html[dir] ._1jHQ218J9GUuXKTH-Xd56L._1Pep451MMPrab_Ygiv8XsG{background-color:\"[theme:neutralTertiary, default:#a6a6a6]\"}.jdr7_b9OPnfUUeTsW9fzI{color:\"[theme:white, default:#ffffff]\";font-size:7px;vertical-align:top}html[dir] .jdr7_b9OPnfUUeTsW9fzI{margin:3px}", ""]);

// exports
exports.locals = {
	"persona": "_2rg5ailL1jR7Z2DjmlnENx",
	"freeBusyStatus": "_1jHQ218J9GUuXKTH-Xd56L",
	"free": "_4aIG4GKXJFxP1-9D4cFzp",
	"unknown": "_1Pep451MMPrab_Ygiv8XsG",
	"freeBusyIcon": "jdr7_b9OPnfUUeTsW9fzI"
};